/**
 * Deterministic math. Only + − × ÷, Math.sqrt and rounding are used, which JavaScript engines
 * compute identically (IEEE 754). Math.sin/cos/exp/pow/hypot are banned in the sim because their
 * last bits differ between engines (docs/architecture.md §3).
 */

const H = Math.SQRT1_2;

/** Unit normals for the octagon directions 0°, 45°, … 315° (0° = right, 90° = down). */
export const OCTAGON_NORMALS: readonly (readonly [number, number])[] = [
  [1, 0],
  [H, H],
  [0, 1],
  [-H, H],
  [-1, 0],
  [-H, -H],
  [0, -1],
  [H, -H],
];

/** e^(−x) for x ≥ 0 via range reduction and a Taylor series. Accurate to ~1e-12 for game use. */
export function expNeg(x: number): number {
  if (x <= 0) return 1;
  let y = x;
  let halvings = 0;
  while (y > 0.125) {
    y *= 0.5;
    halvings++;
  }
  // Σ (−y)^n / n! for n = 0..7, in Horner form
  let r =
    1 +
    y *
      (-1 +
        y * (1 / 2 + y * (-1 / 6 + y * (1 / 24 + y * (-1 / 120 + y * (1 / 720 + y * (-1 / 5040)))))));
  while (halvings-- > 0) r *= r;
  return r;
}

export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}

export function length(x: number, y: number): number {
  return Math.sqrt(x * x + y * y);
}
